/* Proconex — interface de consentement bâtie sur l'API Shopify Customer Privacy.
   Contrat : on ne lit et n'écrit jamais de témoin de consentement à la main ; tout passe par
   window.Shopify.customerPrivacy (shouldShowBanner / currentVisitorConsent / setTrackingConsent). */
(function () {
  'use strict';
  var card = document.querySelector('[data-consent]');
  if (!card) return;
  var box = card.querySelector('.ccard__box');
  var prefs = card.querySelector('[data-consent-prefs]');
  var intro = card.querySelector('[data-consent-intro]');
  var btnAccept = card.querySelector('[data-consent-accept]');
  var btnReject = card.querySelector('[data-consent-reject]');
  var btnSave = card.querySelector('[data-consent-save]');
  var btnCustom = card.querySelector('[data-consent-custom]');
  var boxes = Array.prototype.slice.call(card.querySelectorAll('[data-consent-purpose]'));
  var api = null, opener = null;

  function show() { card.hidden = false; requestAnimationFrame(function () { card.classList.add('is-in'); }); }
  function hide() {
    card.classList.remove('is-in');
    setTimeout(function () { card.hidden = true; card.classList.remove('is-prefs'); if (prefs) prefs.hidden = true; if (btnSave) btnSave.hidden = true; }, 260);
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} opener = null; }
  }
  var PURPOSES = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
  function currentConsent() {
    try { return api.currentVisitorConsent ? api.currentVisitorConsent() : {}; } catch (e) { return {}; }
  }
  /* Le visiteur a-t-il DÉJÀ répondu ? Shopify garde la réponse dans currentVisitorConsent() : une finalité
     vaut "" tant que rien n'a été choisi, puis "yes"/"no". On s'appuie sur cet état (et non sur une variable
     de page) car shouldShowBanner() reste vrai sur cette boutique même après un choix enregistré — c'est ce
     qui faisait revenir la carte à chaque page. */
  function answered() {
    var c = currentConsent();
    for (var i = 0; i < PURPOSES.length; i++) {
      var v = c[PURPOSES[i]];
      if (v === 'yes' || v === 'no' || v === true || v === false) return true;
    }
    return false;
  }
  function fillBoxes() {
    var c = currentConsent();
    boxes.forEach(function (b) {
      var v = c[b.getAttribute('data-consent-purpose')];
      b.checked = v === 'yes' || v === true; /* jamais coché d'avance quand le consentement est requis */
    });
  }
  var saving = false;
  function save(consent) {
    if (!api || !api.setTrackingConsent) return hide();
    if (saving) return;
    saving = true;
    /* Shopify est seul propriétaire de l'état : on lui confie le choix et on ne ferme qu'ensuite.
       Si l'appel échoue, la carte reste affichée pour que le choix puisse être réellement enregistré. */
    var done = false;
    var finish = function (ok) {
      if (done) return; done = true; saving = false;
      if (ok !== false) hide();
    };
    try {
      api.setTrackingConsent(consent, function (res) {
        finish(!(res && res.error));
      });
      setTimeout(function () { finish(true); }, 2500); /* filet : certains navigateurs ne rappellent pas */
    } catch (e) { finish(false); }
  }
  function all(v) { return { analytics: v, marketing: v, preferences: v, sale_of_data: v }; }

  function wire() {
    if (btnAccept) btnAccept.addEventListener('click', function () { save(all(true)); });
    if (btnReject) btnReject.addEventListener('click', function () { save(all(false)); });
    if (btnCustom) btnCustom.addEventListener('click', function () {
      card.classList.add('is-prefs');
      if (prefs) prefs.hidden = false;
      if (btnSave) btnSave.hidden = false;
      if (intro) intro.hidden = true;
      fillBoxes();
      var first = boxes[0]; if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    });
    if (btnSave) btnSave.addEventListener('click', function () {
      var c = {};
      boxes.forEach(function (b) { c[b.getAttribute('data-consent-purpose')] = !!b.checked; });
      c.sale_of_data = !!c.marketing;
      save(c);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !card.hidden) hide(); });
    /* Lien « Gérer mes témoins » du pied de page : rouvre la carte, déjà en mode préférences. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-consent-open]') : null;
      if (!t) return;
      /* « Gérer mes témoins » rouvre toujours le panneau de préférences, même après un choix enregistré. */
      e.preventDefault(); opener = t;
      show(); if (btnCustom) btnCustom.click();
    });
  }

  /* Bannière native Shopify (#shopify-pc__banner) : elle reste pilotée dans l'admin, et c'est elle qui
     détient l'état de consentement. Quand la carte Proconex prend la main, la bannière est neutralisée
     VISUELLEMENT par takeOver() ci-dessous, pour qu'une seule demande soit à l'écran — voir le détail juste
     après. Corollaire à connaître : si ce script ne s'exécute pas (bloqué, erreur de chargement), la classe
     n'est jamais posée et la bannière native s'affiche telle que l'admin la fournit, dans SA langue. Ses
     textes doivent donc être traduits dans Translate & Adapt, sinon un visiteur anglophone la verra en
     français. */
  function nativeBanner() { return document.getElementById('shopify-pc__banner') || document.querySelector('.shopify-pc__banner'); }
  /* Une seule demande à l'écran : la bannière native de Shopify est neutralisée VISUELLEMENT (classe posée sur
     <html>, CSS du thème) tandis que l'état de consentement reste entièrement géré par l'API Shopify — la carte
     Proconex appelle setTrackingConsent, donc rien n'est contourné côté conformité. */
  function takeOver() {
    document.documentElement.classList.add('pcx-consent');
    var n = nativeBanner();
    if (n) n.setAttribute('aria-hidden', 'true');
  }

  function start() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) return;
    wire();                                          /* le lien « Gérer mes témoins » est actif dans tous les cas */
    var must = false;
    try { must = api.shouldShowBanner ? api.shouldShowBanner() : false; } catch (e) { must = false; }
    if (!must || answered()) return;  /* choix déjà enregistré chez Shopify : plus jamais de demande */
    /* Sans choix enregistré, la carte s'affiche sur la PREMIÈRE page de la session puis se tait : un simple
       marqueur d'affichage (sessionStorage) évite de la remontrer à chaque page. Ce marqueur ne vaut NI accord
       NI refus — l'état réel reste celui de l'API Shopify, et une nouvelle visite repose la question. */
    var seen = false;
    try { seen = sessionStorage.getItem('pcx:consent-seen') === '1'; } catch (e) {}
    if (seen) { takeOver(); return; }               /* la bannière native ne revient pas non plus */
    try { sessionStorage.setItem('pcx:consent-seen', '1'); } catch (e) {}
    takeOver(); show();
    /* la bannière native peut être injectée juste après : on la neutralise aussi à ce moment-là */
    setTimeout(takeOver, 600);
    setTimeout(takeOver, 1800);
  }

  /* L'API est chargée par Shopify ; on l'attend proprement (événement officiel + repli borné). */
  /* Shopify annonce chaque enregistrement : la carte se ferme et ne redemandera plus rien tant que le
     consentement reste valide (l'état vit dans Shopify, pas dans une variable de page). */
  document.addEventListener('visitorConsentCollected', function () { if (!card.hidden) hide(); });
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) start(); });
  } else {
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (window.Shopify && window.Shopify.customerPrivacy) { clearInterval(poll); start(); }
      else if (tries > 40) clearInterval(poll);
    }, 250);
  }
})();
